import { useEffect, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { firmDocumentsUrl } from 'common/config/urls';
import { useGuidedTour } from 'components/ui';
import { getFirmDocumentsTour } from 'pages/Documents/FirmDocuments/tours';
import { workspaceNavigationTour } from './workspaceNavigationTour';

const FirmBaseLayoutProductTours = () => {
  const location = useLocation();
  const { firmSlugParam } = useParams<{ firmSlugParam: string }>();
  const { registerTours } = useGuidedTour();
  const firmDocumentsPath = firmSlugParam ? firmDocumentsUrl(firmSlugParam) : '';
  const isFirmDocumentsRoute = Boolean(firmDocumentsPath)
    && (location.pathname === firmDocumentsPath || location.pathname.startsWith(`${firmDocumentsPath}/`));
  const tours = useMemo(() => [
    { definition: workspaceNavigationTour },
    { definition: getFirmDocumentsTour(firmSlugParam), isRecommended: isFirmDocumentsRoute },
  ], [firmSlugParam, isFirmDocumentsRoute]);

  // Register shell-level tours from inside the provider so Help can list them globally.
  useEffect(
    () => registerTours(tours),
    [registerTours, tours]
  );

  return null;
};

export default FirmBaseLayoutProductTours;
